import React, { useEffect, useState } from 'react';
import DeleteModal from '@Client/runner.shared/modal/delete/DeleteModal';
import { getService } from '@Client/runner.hooks/useService';
import { Guid } from '@Shared.Angular/@types/guid';
import IProcedureFlowModel from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureFlowModel';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';

type props = {
  procedureName: string;
  procedureId: Guid;
  closeModal: () => void;
  deleteAction: () => void;
};

function ProcedureDeleteModal(props: props) {
  const { procedureName, procedureId, closeModal, deleteAction } = props;
  const modelerUrlService = getService('tempModelerUrlService');
  const [flowModels, setFlowModels] = useState<IProcedureFlowModel[]>(null);

  useEffect(() => {
    getService('procedureApiService')
      .getFlowModelsUsingProcedure(procedureId)
      .then((results) => {
        return results.sort((a, b) => a.name.localeCompare(b.name));
      })
      .then(setFlowModels);
  }, []);

  return (
    <DeleteModal
      id="procedure-delete-modal"
      title={'Delete SOP'}
      subject={procedureName}
      closeModal={closeModal}
      deleteAction={flowModels?.length === 0 ? deleteAction : undefined}
    >
      <div>
        {flowModels?.length > 0 && (
          <div>
            <div className="warning">
              <i className="fa-light fa-triangle-exclamation red-text"></i> This
              SOP cannot be deleted as it is used in the following flow models:
            </div>
            {flowModels.map((fm) => (
              <div key={fm.id} className="flow-model-info">
                <div>
                  <a
                    href={modelerUrlService.getModelerUrl({
                      flowModelId: fm.id
                    })}
                    target="_blank"
                  >
                    {fm.name}
                  </a>
                </div>
                {fm.isProcedureInDraft && (
                  <Chip
                    name="Draft"
                    color="ccc"
                    title="This SOP is in the flow model's draft version"
                  />
                )}
                {fm.isProcedureInPublished && (
                  <Chip
                    name="Published"
                    color="ccc"
                    title="This SOP is in the flow model's published version"
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </DeleteModal>
  );
}

export default ProcedureDeleteModal;
